import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './styles/main.css';

const savedTheme = localStorage.getItem('ckp_ota_theme');
if (savedTheme === 'light' || savedTheme === 'dark') {
  document.documentElement.setAttribute('data-theme', savedTheme);
} else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
  document.documentElement.setAttribute('data-theme', 'dark');
} else {
  document.documentElement.setAttribute('data-theme', 'light');
}

createApp(App).use(router).mount('#app');
